export const GROUP_STAGE_ROUND = 'GROUP_STAGE';

const DOUBLE_COST_KNOCKOUT_ROUNDS = ['LAST_32', 'LAST_16', 'QUARTER_FINALS'];

export function getMatchJokerCost(round: string): number {
  if (round === GROUP_STAGE_ROUND) {
    return 1;
  }

  if (DOUBLE_COST_KNOCKOUT_ROUNDS.includes(round)) {
    return 2;
  }

  return 3;
}
